module.exports = __webpack_public_path__ + "static/img/banner.c837137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2023/banner.png
// module id = jWLX
// module chunks = 1